import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, Input, OnInit, ViewChild } from '@angular/core';
import {
  DxButtonComponent,
  DxDataGridComponent,
  DxLoadPanelComponent,
  DxPopupComponent,
} from 'devextreme-angular';
import {
  DxiDataGridItemComponent,
  DxoDataGridSelectionComponent,
  DxoDataGridToolbarComponent,
} from 'devextreme-angular/ui/data-grid';
import {
  DxiButtonComponent,
  DxiColumnComponent,
  DxoColumnChooserComponent,
  DxoEditingComponent,
  DxoExportComponent,
  DxoFilterRowComponent,
  DxoHeaderFilterComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import CustomStore from 'devextreme/data/custom_store';
import { firstValueFrom } from 'rxjs';
import {
  TIPI_PROPRIETA_ARTICOLO_LIST,
  TIPO_PROPRIETA_ARTICOLO_ALFANUMERICO,
  TIPO_PROPRIETA_ARTICOLO_DATA,
  TIPO_PROPRIETA_ARTICOLO_NUMERO,
  TIPO_PROPRIETA_ARTICOLO_SELMULTI,
} from 'src/app/consts/tipi-proprieta-articolo';
import { Articoli } from 'src/app/models/articoli';
import { TipiArticoli } from 'src/app/models/tipi-articoli';
import { ArticoliMatricolaService } from 'src/app/shared/services/articoli-matricola.service';
import { TipiArticoliService } from 'src/app/shared/services/tipi-articoli.service';
import { ConvertError } from 'src/app/utils/gestione-errori';
import { notificaMessaggio } from 'src/app/utils/notifiche-utils';
import { PopupBarCodeComponent } from '../../popups/popup-barcode/popup-barcode.component';
import { PrintBarCodeModel } from 'src/app/models/print-barcode-model';

@Component({
  selector: 'app-grid-matricole-articolo',
  templateUrl: './grid-matricole-articolo.component.html',
  styleUrls: ['./grid-matricole-articolo.component.scss'],
  imports: [
    DxDataGridComponent,
    DxiColumnComponent,
    DxoLookupComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoExportComponent,
    DxoEditingComponent,
    DxoColumnChooserComponent,
    DxiButtonComponent,
    DxoTextsComponent,
    DxoDataGridSelectionComponent,
    DxoDataGridToolbarComponent,
    DxiDataGridItemComponent,
    DxButtonComponent,
    DxPopupComponent,
    PopupBarCodeComponent,
    DxLoadPanelComponent
  ],
})
export class GridMatricoleArticoloComponent implements OnInit {
  private tipiArticoliService = inject(TipiArticoliService);
  private articoliMatricolaService = inject(ArticoliMatricolaService);

  @ViewChild('dataGridArticoliMatricola', { static: false })
  dataGridArticoliMatricola: DxDataGridComponent;
  @Input() articolo: Articoli;

  readonly listTipiProps = TIPI_PROPRIETA_ARTICOLO_LIST;
  readonly TIPO_PROPRIETA_ARTICOLO_ALFANUMERICO =
    TIPO_PROPRIETA_ARTICOLO_ALFANUMERICO;
  readonly TIPO_PROPRIETA_ARTICOLO_NUMERO = TIPO_PROPRIETA_ARTICOLO_NUMERO;
  readonly TIPO_PROPRIETA_ARTICOLO_DATA = TIPO_PROPRIETA_ARTICOLO_DATA;
  readonly TIPO_PROPRIETA_ARTICOLO_SELMULTI = TIPO_PROPRIETA_ARTICOLO_SELMULTI;

  loadPanelVisible = false;

  columnResizingMode = 'widget';

  tipoArticolo: TipiArticoli;
  listPropsArtMatricola: any[];
  dataSource: any;
  popupInfoBarCode: boolean = false;
  printBarcodeModel: PrintBarCodeModel = new PrintBarCodeModel();

  constructor() {
    this.onSalvaClick = this.onSalvaClick.bind(this);
  }

  ngOnInit() {
    this.loadTipologia();
    this.loadDataSource();
  }

  loadTipologia() {
    this.tipiArticoliService.get(this.articolo?.idTipo).subscribe({
      next: (res) => {
        this.tipoArticolo = res;
        this.listPropsArtMatricola = JSON.parse(res.propJSON);
      },
      error: (error) => {
        ConvertError(error, 'Errore recupeto tipi Articolo');
      },
    });
  }

  onRowUpdating(e) {
    const updatedProps = Object.assign(e.oldData.props, e.newData.props);
    e.newData = Object.assign(e.oldData, e.newData);
    e.newData.props = updatedProps;
  }

  loadDataSource() {
    this.dataSource = new CustomStore({
      key: 'id',
      load: () => {
        return firstValueFrom(
          this.articoliMatricolaService.list(this.articolo.id),
        )
          .then((response) => {
            return {
              data: response.map((item) => {
                let newItem: any;
                newItem = item;
                newItem.props = new Object();
                const proprieta = JSON.parse(item.propJson);
                this.listPropsArtMatricola?.forEach((element) => {
                  const prop = proprieta.find((p) => p.nome == element.nome);
                  newItem.props[element.nome] = prop?.valore;
                });
                return newItem;
              }),
            };
          })
          .catch(() => {
            throw 'Data loading error';
          });
      },
      update: (key, values) => {
        //data Scadenza
        if (values.dataScadenza) {
          const dataNascita = new Date(values.dataScadenza);
          const realDay = dataNascita.getDate();
          const realMonth = dataNascita.getMonth();
          const realYear = dataNascita.getFullYear();
          values.dataScadenza = new Date(
            Date.UTC(realYear, realMonth, realDay),
          );
        }
        values.propJson = this.reconvertDataMapped(
          values.propJson,
          values.props,
          this.listPropsArtMatricola,
        );
        return firstValueFrom(this.articoliMatricolaService.update(key, values))
          .then(() => {
            console.log('articolo matricola updated');
          })
          .catch(() => {
            throw 'Update failed';
          });
      },
      remove: (values) => {
        console.log(values);
        return (
          firstValueFrom(this.articoliMatricolaService.remove(values))
            //.catch(() => { throw 'Deletion failed' });
            .then(() => console.log('delete eseguito'))
            .catch((error: HttpErrorResponse) => {
              if (error.status == 500) {
                throw error.error.title;
              } else {
                throw 'Deletion failed';
              }
            })
        );
      },
    });
  }

  reconvertDataMapped(origJsonStr, currentProps, propsTipo) {
    const origData = JSON.parse(origJsonStr);
    propsTipo?.forEach((element) => {
      if (origData.find((p) => p.nome == element.nome)) {
        origData.find((p) => p.nome == element.nome).valore =
          currentProps[element.nome];
      } else {
        const newData = {
          nome: element.nome,
          tipo: element.tipo,
          obbligatorio: element.obbligatorio,
          controlloNotifica: element.controlloNotifica,
          selMultiplaDati: element.selMultiplaDati,
          valore: currentProps[element.nome],
        };
        origData.push(newData);
      }
    });
    return JSON.stringify(origData);
  }

  getDataType(tipo) {
    if (tipo == TIPO_PROPRIETA_ARTICOLO_NUMERO) {
      return 'number';
    } else if (tipo == TIPO_PROPRIETA_ARTICOLO_DATA) {
      return 'date';
    }
    return 'string';
  }

  getDataFormat(tipo) {
    if (tipo == TIPO_PROPRIETA_ARTICOLO_NUMERO) {
      return '0';
    } else if (tipo == TIPO_PROPRIETA_ARTICOLO_DATA) {
      return 'dd/MM/yyyy';
    }
    return '';
  }

  onEsciClick() {
    //this.popupGestioneArticoliMatricolaEventEmitter.next(null);
  }

  onSalvaClick() {
    /* this.dataGridArticoliMatricola.instance.saveEditData()
       .then(() => {
         notify("Dati articoli matricola salvati.", "success", 3000);
         this.popupGestioneArticoliMatricolaEventEmitter.next(true);
       })
       .catch(() => notify("Si sono verificati errori nel salvataggio.", "warning", 3000));
       */
  }

  stampaMatricole() {
    const keys = this.dataGridArticoliMatricola.instance.getSelectedRowKeys() as number[];
    if (keys.length == 0) {
      notificaMessaggio('Selezionare almeno una matricola', 'warning');
      return;
    }
    this.printBarcodeModel.idsObject = keys;
    this.popupInfoBarCode = true;
  }

  onPopupBarcodeEventEmitter(event) {
    this.popupInfoBarCode = false;
    this.loadPanelVisible = true;
    this.printBarcodeModel.grande = event.grande;
    this.printBarcodeModel.numeroCopie = event.numeroCopie;
    this.articoliMatricolaService
      .stampaEtichette(this.printBarcodeModel)
      .subscribe({
        next: (res) => {
          this.dataGridArticoliMatricola.instance.deselectAll();
          this.loadPanelVisible = false;
          const url = window.URL.createObjectURL(res);
          window.open(url);
        },
        error: (err) => {
          this.loadPanelVisible = false;
          if (err?.error?.title) {
            notificaMessaggio(err.error.title, 'error');
          } else {
            notificaMessaggio('Errore stampa Etichetta', 'error');
          }
        },
      });
  }
}
